<template>
  <div>

      <div class="mt-8 lg:mt-20 p-5 lg:p-10 bg-blue-300 rounded-lg border-blue-800 border-4">
        
        <label>{{$t('app.appLaunch')}}</label>  
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>